'use strict';

import React, { PropTypes } from 'react';
import PageControls from '../molecules/PageControls';
import Button from '../atoms/Button';
import PureRenderMixin from '../mixins/PureRenderMixin';
import SidebarActionCreators from '../actions/SidebarActionCreators';
import SidebarTypes from '../constants/SidebarTypes';

var DraftFeedbackControls = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    draftUuid: PropTypes.string.isRequired
  },

  render() {
    return (
      <PageControls>
        <PageControls.Container>
          <Button color='green'
                  fill
                  onClick={this.handleLeaveFeedbackClick}
                  context='PageControls'
                  size='large'>
            Leave Feedback
          </Button>
        </PageControls.Container>
      </PageControls>
    );
  },

  handleLeaveFeedbackClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.LEAVE_DRAFT_FEEDBACK, {
      draftUuid: this.props.draftUuid
    });
  }
});

export default DraftFeedbackControls;



/** WEBPACK FOOTER **
 ** ./pageControls/DraftFeedbackControls.jsx
 **/